import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Rss',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: __props.fillColor,
    class: "mb-1.5 mt-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M8 8V10.5C15.4751 10.5 21.5 16.5249 21.5 24H24C24 15.1751 16.8249 8 8 8ZM8 14.5V17C11.8889 17 15 20.1111 15 24H17.5C17.5 18.764 13.236 14.5 8 14.5ZM8 21V24H11C11 22.3375 9.66251 21 8 21Z",
      fill: __props.strokeColor
    }, null, 8 /* PROPS */, _hoisted_2)
  ], 8 /* PROPS */, _hoisted_1))
}
}

})